<div
    class="relative grow overflow-y-auto"
    [ngClass]="{ 'blur-[2px] pointer-events-none [&_*]:select-none': saving() }"
>
    @if (saving()) {
        <div
            class="absolute flex left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 justify-center items-center z-50"
        >
            <mat-spinner [diameter]="32"></mat-spinner>
        </div>
    }

    <div class="flex flex-col gap-4 bg-valamargray border-2 static p-4">
        <button class="flex valben-button text-lg ml-auto" (click)="save()">Spremi</button>

        <valben-dictionary-input
            [formField]="perkForm.names"
            title="Naziv"
        ></valben-dictionary-input>

        <valben-dictionary-input
            [formField]="perkForm.descriptions"
            [textArea]="true"
            [richText]="true"
            title="Opis"
        ></valben-dictionary-input>

        <valben-date-range-picker
            [startField]="perkForm.activeFrom"
            [endField]="perkForm.activeTo"
            [minDate]="tomorrow"
            [showTodayButton]="false"
            title="Aktivan od i do"
        ></valben-date-range-picker>

        <valben-boolean-input
            [formField]="perkForm.isActive"
            title="Aktivan"
        ></valben-boolean-input>

        <valben-file-input
            [formField]="perkForm.image"
            title="Prenesi sliku ili direktni url postojeće slike"
            fileType="image/*"
            [isPerksPreview]="true"
        ></valben-file-input>

        <valben-categories-input
            [formField]="perkForm.categoryIds"
            [type]="categoriesType"
            title="Kategorije"
        ></valben-categories-input>

        <valben-locations-input
            [formField]="perkForm.locationIds"
            title="Lokacije"
        ></valben-locations-input>

        <valben-filters [(value)]="filters" />

        <div class="flex gap-4 justify-end items-center select-none">
            <button class="valben-button text-lg" (click)="back()">Natrag</button>
            <button class="text-lg valben-button" (click)="draft()">Skica</button>
            <button class="text-lg valben-button" (click)="save()">Spremi</button>
        </div>
    </div>
</div>
